import { Popover } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import FilterChip from '../FilterChip';
import styles from '../styles.module.scss';
import { ChipData } from '../types';

type MoreFiltersPopoverProps = {
  chips: ChipData[];
  onRemove: (chip: ChipData) => void;
};

export const MoreFiltersPopover: FC<MoreFiltersPopoverProps> = ({
  chips,
  onRemove,
}) => {
  const { t } = useTranslation('common.FilterChips');

  const content = (
    <div className={styles.moreFiltersContent}>
      {chips.map((chip) => (
        <FilterChip
          key={chip.id}
          fieldLabel={chip.label}
          displayValue={chip.displayValue}
          onRemove={() => onRemove(chip)}
          className={styles.popoverChip}
        />
      ))}
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      placement="bottomLeft"
      overlayClassName={styles.moreFiltersPopover}
    >
      <span className={styles.moreButton}>
        +{chips.length} {t('more')}
      </span>
    </Popover>
  );
};
